import { render } from "./Field.vue?vue&type=template&id=3dd8990e"
import script from "./Field.vue?vue&type=script&lang=js"
export * from "./Field.vue?vue&type=script&lang=js"
script.render = render

export default script